import flow from 'lodash/flow';
import Slider from './Slider';
import type {
  CustomCompanyFilter,
  RuleFunction,
} from '../../MoreFiltersConfig/filters';

export const snapToSoftMinMax = (min, max, softMin, softMax) => (value) =>
  value > softMax ? max : value < softMin ? min : value;

interface FilterProps {
  onChange: (id: string, values: number[]) => void;
  currentValue: number | number[];
  valueResolver: ((range: number) => number) | ((range: number[]) => number[]);
  rule: RuleFunction;
}

const RangeFilter = ({
  labels,
  max,
  min,
  step,
  currentValue,
  onChange,
  id,
  valueResolver,
  rule,
}: FilterProps & CustomCompanyFilter) => {
  return (
    <Slider
      min={min || 0}
      max={max || 0}
      step={step || 0}
      value={currentValue}
      labels={(labels && Object.entries(labels)) || []}
      onChange={(values) => {
        const valueToRule = flow([valueResolver, rule]);
        onChange(id, valueToRule(values));
      }}
    />
  );
};

const SliderFilter = ({
  onChange,
  id,
  valueResolver,
  rule,
  labels,
  max,
  min,
  step,
  currentValue,
}: FilterProps & CustomCompanyFilter) => {
  return (
    <Slider
      min={min || 0}
      max={max || 0}
      step={step || 0}
      value={currentValue}
      labels={(labels && Object.entries(labels)) || []}
      onChange={(values) => {
        const valueToRule = flow([valueResolver, rule]);
        onChange(id, valueToRule(values));
      }}
    />
  );
};

const controls = { range: RangeFilter, slider: SliderFilter };
export { controls as default };
